import { Link, Outlet, useLocation } from 'react-router-dom';

const classNames = {
  active:
    'inline-block p-4 text-blue-600 rounded-t-lg border-b-2 border-blue-600 active dark:text-blue-500 dark:border-blue-500',
  inactive:
    'inline-block p-4 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300',
};

const AdminPage = () => {
  const location = useLocation();

  console.log(location.pathname);

  return (
    <div style={{ margin: '2rem' }} className="space-y-2">
      <h1 className="text-white text-xl">Adminbereich</h1>

      <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
        <ul className="flex flex-wrap -mb-px">
          <li className="mr-2">
            <Link
              to="/admin/all-users"
              className={location.pathname.includes('all-users') ? classNames.active : classNames.inactive}
            >
              Nutzer
            </Link>
          </li>
          <li className="mr-2">
            <Link
              to="/admin/all-wishes"
              className={location.pathname.includes('all-wishes') ? classNames.active : classNames.inactive}
            >
              Wünsche
            </Link>
          </li>
        </ul>
      </div>

      <Outlet />
    </div>
  );
};

export default AdminPage;
